import { useMemo } from 'react';
import { useApiGet } from '../utils/httpClientTs';
import { getGroupTypes } from '../endpoints/groups';
import { GroupScope, GroupType } from '../types/group';
import { buildScopeMapFromGroupTypes } from '../utils/groupTypeRoleSelection';

const SCOPES: GroupScope[] = ['international', 'spd_chapter', 'local_chapter'];

export function useGroupTypeNameMap(queryKeySuffix = 'name-map') {
  const { data: internationalGroups = [] } = useApiGet<GroupType[]>(
    ['group-types', 'international', queryKeySuffix],
    () => getGroupTypes('international'),
    { enabled: true }
  );
  const { data: spdGroups = [] } = useApiGet<GroupType[]>(
    ['group-types', 'spd_chapter', queryKeySuffix],
    () => getGroupTypes('spd_chapter'),
    { enabled: true }
  );
  const { data: localGroups = [] } = useApiGet<GroupType[]>(
    ['group-types', 'local_chapter', queryKeySuffix],
    () => getGroupTypes('local_chapter'),
    { enabled: true }
  );

  const groupNameById = useMemo(() => {
    const map = new Map<string, string>();
    for (const g of [...internationalGroups, ...spdGroups, ...localGroups]) {
      map.set(g.id, g.name);
    }
    return map;
  }, [internationalGroups, spdGroups, localGroups]);

  const scopeByGroupTypeId = useMemo(
    () =>
      buildScopeMapFromGroupTypes(internationalGroups, spdGroups, localGroups),
    [internationalGroups, spdGroups, localGroups]
  );

  const isLoading =
    internationalGroups.length === 0 &&
    spdGroups.length === 0 &&
    localGroups.length === 0;

  return {
    groupNameById,
    scopeByGroupTypeId,
    internationalGroups,
    spdGroups,
    localGroups,
    scopes: SCOPES,
    isLoading,
  };
}
